import dayjs from "dayjs";
import { DEFAULT_DATE_FORMAT } from "../configs/dateConfig";

export const displayDate = (value?: string | Date | null): string => {
    if (!value) return "";
    const date = dayjs(value);
    return date.isValid() ? date.format(DEFAULT_DATE_FORMAT) : "";
};
